import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import type { PropertyAdEditorFormValues } from '../../types/propertyAdEditor';

import { MyButton } from '../uiComponents/MyButton';
import { AiReviewFieldNotice, useAiListingReview } from './AiListingReview';
import { EditorSection } from './EditorSection';

export const PROPERTY_AD_DESCRIPTION_MAX_LENGTH = 8000;
export const PROPERTY_AD_DESCRIPTION_MAX_LENGTH_MESSAGE =
  'Description must be shorter than or equal to 8000 characters';

export const DescriptionSection = () => {
  const { control } = useFormContext<PropertyAdEditorFormValues>();
  const aiReview = useAiListingReview();

  return (
    <EditorSection
      description='Add information that helps clients understand the property'
      headerAction={
        <MyButton
          data={{
            buttonName: 'Generate with AI',
            buttonType: 'button',
            customWidth: '150px',
            size: 'small',
            variant: 'contained',
          }}
          disabled
        />
      }
      title='Description'
      titleId='property-ad-description-title'
    >
      <Controller
        control={control}
        name='description'
        rules={{
          maxLength: {
            message: PROPERTY_AD_DESCRIPTION_MAX_LENGTH_MESSAGE,
            value: PROPERTY_AD_DESCRIPTION_MAX_LENGTH,
          },
        }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={fieldState.invalid}
            fullWidth
            helperText={fieldState.error?.message ?? ''}
            inputProps={{
              'aria-label': 'Description',
              maxLength: PROPERTY_AD_DESCRIPTION_MAX_LENGTH,
            }}
            multiline
            placeholder='Add a description of your property'
            rows={10}
            onChange={(event) => {
              field.onChange(event);
              aiReview?.resolveField('description');
            }}
          />
        )}
      />
      <AiReviewFieldNotice target='description' />
    </EditorSection>
  );
};
